/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_TitleInputs */

const en_welcome_title = /** @type {(inputs: Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting up your session`)
};

const fr_welcome_title = /** @type {(inputs: Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation de votre session`)
};

const ms_sg2_welcome_title = /** @type {(inputs: Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyediakan sesi anda`)
};

/**
* | output |
* | --- |
* | "Setting up your session" |
*
* @param {Welcome_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_title = /** @type {((inputs?: Welcome_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_title(inputs)
	if (locale === "fr") return fr_welcome_title(inputs)
	return ms_sg2_welcome_title(inputs)
});